import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as actions from "../../../store/usersLabs/actions";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { withStyles } from "@material-ui/styles";
import Switch from '@material-ui/core/Switch';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import { usersStatisticsRequest } from "../../../store/users/actions";

const MySwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    '&$checked': {
      transform: 'translateX(16px)',
      color: "#FFF",
      '& + $track': {
        backgroundColor: '#24D7D3',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#24D7D3',
      border: '6px solid #fff',
    },
  },
  thumb: {
    width: 22,
    height: 22,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

const Labs = ({ intl: { messages } }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [searchValues, setSearchValues] = useState({});
  const lang = localStorage.getItem("lang") || "en";
  const { usersLabs } = useSelector((state) => state.usersLabs);
  const { usersStatistics } = useSelector((state) => state.users);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [blockConfirmation, setBlockConfirmation] = useState(false);
  const [selectedRef, setSelectedRef] = useState({});

  useEffect(() => {
    //Get internal Users list
    dispatch(
      actions?.getUsersLabsRequest({
        page: 1,
        sort: "blocked_at,asc",
        roleId: 7,
      })
    );
    dispatch(usersStatisticsRequest());
    return () => {
      dispatch(actions.getUsersLabsReceive([]));
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //table n grid view render
  const headings = [
    messages.usersLabs.ref_id,
    lang === 'ar' ? messages.usersLabs.arabic_name : messages.usersLabs.english_name,
    lang === 'ar' ? messages.usersLabs.english_name : messages.usersLabs.arabic_name,
    messages.usersLabs.city,
    messages.usersLabs.location,
    messages.usersLabs.status,
    messages.usersLabs.actions,
  ];

  const renderTableData = () => {
    return usersLabs?.data?.map((lab, i) => {
      const {
        code,
        name,
        city_name,
        map_link,
        is_blocked,
      } = lab;
      return [
        code,
        lang === 'ar' ? <Tooltip title={name?.ar} placement="bottom" onClick={(e) => history.push(`/users/labs/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="arabic_name">
            {name?.ar?.length > 25 ? `${name?.ar.substring(0,25)}...` : name?.ar}
          </span>
        </Tooltip> :
        <Tooltip title={name?.en} placement="bottom" onClick={(e) => history.push(`/users/labs/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="english_name">
            {name?.en?.length > 25 ? `${name?.en.substring(0,25)}...` : name?.en}
          </span>
        </Tooltip>,
          lang === 'ar' ? <Tooltip title={name?.en} placement="bottom" onClick={(e) => history.push(`/users/labs/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="english_name">
            {name?.en?.length > 25 ? `${name?.en.substring(0,25)}...` : name?.en}
          </span>
        </Tooltip> :
        <Tooltip title={name?.ar} placement="bottom" onClick={(e) => history.push(`/users/labs/edit/${lab.id}`)} style={{ cursor: "pointer" }}>
          <span className="arabic_name">
            {name?.ar?.length > 25 ? `${name?.ar.substring(0,25)}...` : name?.ar}
          </span>
        </Tooltip>,
        city_name,
        <a href={map_link} target="_blank" rel="noreferrer" className="link">{messages.usersLabs.showLink}</a>,
        <MySwitch checked={!is_blocked} name="block" onChange={() => {
          if (!is_blocked) {
            setSelectedRef(lab);
            setBlockConfirmation(true)
          } else {
            dispatch(actions.activeUsersLabRequest(lab.id))
          }
        }} />,
        <div className="actions-icons">
          <EditRoundedIcon onClick={() => history.push(`/users/labs/edit/${lab.id}`)} />
          <DeleteForeverRoundedIcon onClick={() => {
            setSelectedRef(lab);
            setDeleteConfirmation(true);
          }}/>
        </div>,
      ];
    });
  };

  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.getUsersLabsRequest({
        page,
        sort: "blocked_at,asc",
        roleId: 7,
        ...searchValues,
      })
    );
  };

  return (
    <>
      {usersLabs ? (
        <div style={{ padding: '5px 0'}}>
          <button className={`myBtn ${lang === 'ar' && 'rtl'}`} 
              onClick={(e) => {e.preventDefault(); history.push("/users/labs/add")}} >
              <AddCircleOutlineOutlinedIcon />{messages.usersLabs.add_new}
          </button>
          <TableGridView
            title={
              <>
                <FormattedMessage
                  values={{
                    total: usersLabs?.total,
                    totals: usersStatistics?.labs,
                  }}
                  id="usersLabs.refs_of"
                  defaultMessage={messages.usersLabs.refs_of}
                />
              </>
            }
            Form={<Filterform setSearchValues={setSearchValues} />}
            table={{
              stickyHeader: true,
              headings: headings,
              data: renderTableData(),
              headClass: "bg-white table-head",
              noData: messages.noData.no_data,
            }}
            //gridView={renderGridView}
            pagination={{
              count: usersLabs.last_page,
              page: usersLabs.current_page,
              handleChange: handlePageChange,
            }}
          />
        </div>
      ) : null}

      <ConfirmDialog show={deleteConfirmation} 
                     onCancel={() => {
                        setDeleteConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.deleteUsersLabRequest(selectedRef.id))
                        setDeleteConfirmation(false);
                     }}
                     content={messages.programs.delete_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
      
      <ConfirmDialog show={blockConfirmation} 
                     onCancel={() => {
                        setBlockConfirmation(false)
                      }}
                     onConfirm={() => {
                        dispatch(actions.desactiveUsersLabRequest(selectedRef.id))
                        setBlockConfirmation(false);
                     }}
                     content={messages.usersLabs.desactive_confirmation}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
    </>
  );
};

export default injectIntl(Labs);
